// extracted by mini-css-extract-plugin
export default {"tutorialBG":"TutorialStyles_tutorialBG__LKJhC","show":"TutorialStyles_show__iuWBa","tutorial":"TutorialStyles_tutorial__88ukt","skipCount":"TutorialStyles_skipCount__rhHvX"};